import styled from 'styled-components';

interface PDFPageViewWrapperProps {
  height?: string;
}

export const PDFPageViewWrapper = styled.div<PDFPageViewWrapperProps>`
  height: ${(p) => p.height || '100vh'};
`;
